import { render, staticRenderFns } from "./prompt.vue?vue&type=template&id=dc84d52e&scoped=true&"
import script from "./prompt.vue?vue&type=script&lang=js&"
export * from "./prompt.vue?vue&type=script&lang=js&"
import style0 from "./prompt.vue?vue&type=style&index=0&id=dc84d52e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc84d52e",
  null
  
)

export default component.exports